/**
 * _support_alerts.js — pure rules of the support alerts
 * (support_alerts_controller.js), tested in tests/js/support_alerts.test.mjs.
 *
 * An alert is for a message from the other side: a customer hears staff, staff
 * hear customers. System lines and my own side never alert. What alerts
 * depends on whether the person is looking at the Support tab.
 */

import { linkLabels } from "./_support_messages.js";

const PREVIEW_CHARS = 80;

/** Whether a message comes from the side the viewer is talking to. */
export function isFromOtherSide(message, meId, isStaff) {
    if (message.kind === 'system' || message.sender_user_id === null) return false;
    if (message.sender_user_id === meId) return false;
    return isStaff ? !message.is_staff_sender : Boolean(message.is_staff_sender);
}

/**
 * What a new message should do. Looking means the panel is open on the
 * Support tab in a visible document: then the chat view shows and reads it,
 * and nothing alerts. The bubble is only for a closed panel.
 */
export function shouldAlert({ fromOtherSide, panelOpen, supportTabActive, documentHidden }) {
    if (!fromOtherSide) return { count: false, bubble: false, sound: false };
    const looking = panelOpen && supportTabActive && !documentHidden;
    return { count: !looking, bubble: !panelOpen, sound: !looking };
}

export function badgeText(count) {
    if (!count || count <= 0) return '';
    return count > 9 ? '9+' : String(count);
}

/** The bubble's one line: the start of the message, or that it is a photo. */
export function previewText(message) {
    if (message.kind === 'system') return '';
    if (!message.body) return message.kind === 'image' ? 'Sent a photo' : '';
    return linkLabels(message.body).slice(0, PREVIEW_CHARS);
}
